const defaultState = {
  appName: 'Miami Gardens 2608 LLC.',
  files: {}
};

export default (state = defaultState, action) => {
	return state;
}


// WEBPACK FOOTER //
// ./src/reducers/common.js